import React from 'react';
import CategoryState from './categoryState/CategoryState';
import CategoryControlPanel from './components/CategoryControlPanel/CategoryControlPanel';
import Categories from './components/Categories/Categories';
import { ModalWindows } from './components/ModalWindows';
import style from './index.module.scss';

const CategoryPage: React.FC = () => {
	return (
		<CategoryState>
			<div className={style.container} data-test="CategoryPage">
				<CategoryControlPanel />
				<Categories />
				<ModalWindows />
			</div>
		</CategoryState>
	);
};

export default CategoryPage;
